import React from "react";

const ContasConectadas = ({
  contasConectadas,
  contasSelecionadas,
  setContasSelecionadas,
  notifyColor,
  handleSelecionarConta,
  handleSelecionarTodas,
  todasSelecionadas,
  setEtapaAtual,
  etapaAtual,
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center", // Centraliza o conteúdo horizontalmente
        justifyContent: "flex-start", // Alinha o conteúdo ao topo
        minHeight: "100vh", // Garante que o componente ocupe a altura total da tela
        padding: "20px", // Espaçamento interno
        boxSizing: "border-box",
      }}
    >
      {/* Botão Próximo */}
      <button
        style={{
          marginBottom: 24, // Espaçamento entre o botão e o restante do conteúdo
          background: contasSelecionadas.length > 0 ? notifyColor : "#ccc", // Ativo apenas se pelo menos uma conta estiver selecionada
          color: "#fff",
          border: "none",
          borderRadius: 8,
          padding: "12px 24px",
          fontWeight: "bold",
          fontSize: 16,
          cursor: contasSelecionadas.length > 0 ? "pointer" : "not-allowed", // Desabilita o clique se nenhuma conta estiver selecionada
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          transition: "background 0.3s",
          alignSelf: "center", // Centraliza o botão no contêiner
        }}
        onClick={() => {
          if (contasSelecionadas.length > 0) {
            setEtapaAtual(etapaAtual + 1); // Vai para a próxima etapa
          }
        }}
        disabled={contasSelecionadas.length === 0} // Desabilita o botão se nenhuma conta estiver selecionada
      >
        Próximo
      </button>

      <h3 style={{ color: notifyColor, marginBottom: 24, textAlign: "center" }}>
        Contas conectadas
      </h3>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 16,
          alignItems: "center",
          justifyContent: "center",
          marginTop: 16,
        }}
      >
        <div
          style={{
            marginBottom: 12,
            display: "flex",
            alignItems: "center",
            gap: 8,
          }}
        >
          <input
            type="checkbox"
            checked={todasSelecionadas}
            onChange={handleSelecionarTodas}
            style={{
              accentColor: notifyColor,
              width: 20,
              height: 20,
              cursor: "pointer",
            }}
            id="selecionarTodasContas"
          />
          <label
            htmlFor="selecionarTodasContas"
            style={{
              fontWeight: "bold",
              color: "#005c53",
              cursor: "pointer",
            }}
          >
            Selecionar todas as contas
          </label>
        </div>
        {contasConectadas.map((conta) => (
          <div
            key={conta.nome}
            style={{
              background: "#f0f4f8",
              borderRadius: 12,
              padding: 16,
              maxWidth: 320,
              width: "100%",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              display: "flex",
              alignItems: "center",
              gap: 16,
            }}
          >
            <input
              type="checkbox"
              checked={contasSelecionadas.some((c) => c.nome === conta.nome)}
              onChange={() => handleSelecionarConta(conta.nome)}
              style={{
                accentColor: notifyColor,
                width: 20,
                height: 20,
                cursor: "pointer",
                marginRight: 12,
              }}
            />
            <div
              style={{
                position: "relative",
                width: 56,
                height: 56,
                marginRight: 12,
              }}
            >
              <img
                src={conta.foto}
                alt={conta.nome}
                style={{
                  width: 56,
                  height: 56,
                  borderRadius: "50%",
                  objectFit: "cover",
                  border: "2px solid #51a197",
                }}
              />
              <span
                style={{
                  position: "absolute",
                  bottom: 4,
                  right: 4,
                  width: 16,
                  height: 16,
                  borderRadius: "50%",
                  background: "#28a745",
                  boxShadow: "0 0 8px 2px #28a745",
                  animation: "pulse 1.2s infinite",
                }}
              />
            </div>
            <div>
              <div
                style={{
                  fontWeight: "bold",
                  color: "#005c53",
                  fontSize: 18,
                }}
              >
                {conta.nome}
              </div>
            </div>
          </div>
        ))}
      </div>
      <style>
        {`
          @keyframes pulse {
            0% { box-shadow: 0 0 0 0 #51a197; }
            70% { box-shadow: 0 0 8px 6px #51a19744; }
            100% { box-shadow: 0 0 0 0 #51a197; }
          }
        `}
      </style>
    </div>
  );
};

export default ContasConectadas;